import { Table, Typography } from 'antd';
import React from 'react';

import especies from '../../../assets/files/especies.xlsx';
import produtos from '../../../assets/files/produtos.xlsx';
import SubHeader from '../../../components/SubHeader';
import { Card } from '../../../components/SubHeader/styles';
import { CheckOutlinedStyle, DownloadLink } from './styles';

const { Title, Paragraph, Text, Link } = Typography;

export default function DocumentacaoApi() {
  const breadcrumbs = [
    {
      path: '/lotes/',
      breadcrumbName: 'Lotes',
    },
    {
      breadcrumbName: 'Documentação API',
    },
  ];

  const dadosAtributosPayload = [
    {
      atributo: 'cliente_pagador_cnpj',
      descricao: 'CNPJ do cliente que efetiva o pagamento',
      obrigatorio: <CheckOutlinedStyle />,
    },
    {
      atributo: 'produto_id',
      descricao: (
        <DownloadLink
          href={produtos}
          target="_self"
          download="produtos-shipper.csv"
        >
          Baixe a planilha referência aqui
        </DownloadLink>
      ),
      obrigatorio: <CheckOutlinedStyle />,
    },
    {
      atributo: 'especie_id',
      descricao: (
        <DownloadLink
          href={especies}
          target="_self"
          download="especies-shipper.csv"
        >
          Baixe a planilha referência aqui
        </DownloadLink>
      ),
      obrigatorio: <CheckOutlinedStyle />,
    },
    {
      atributo: 'origem.cnpj_cliente',
      descricao: 'CNPJ do cliente detentor da carga',
      obrigatorio: '',
    },
    {
      atributo: 'origem.nome_cidade',
      descricao: 'Nome da cidade origem',
      obrigatorio: <CheckOutlinedStyle />,
    },
    {
      atributo: 'origem.sigla_estado',
      descricao: 'Sigla do estado origem (PR, RN, SP) etc...',
      obrigatorio: <CheckOutlinedStyle />,
    },
    {
      atributo: 'destino.cnpj_cliente',
      descricao: 'CNPJ do cliente destinatário da carga',
      obrigatorio: '',
    },
    {
      atributo: 'destino.nome_cidade',
      descricao: 'Nome da cidade destino',
      obrigatorio: <CheckOutlinedStyle />,
    },
    {
      atributo: 'destino.sigla_estado',
      descricao: 'Sigla do estado destino (PR, RN, SP) etc...',
      obrigatorio: <CheckOutlinedStyle />,
    },
    {
      atributo: 'coleta.cnpj_cliente',
      descricao: 'CNPJ do cliente onde ocorre o carregamento da carga',
      obrigatorio: <CheckOutlinedStyle />,
    },
    {
      atributo: 'entrega.cnpj_cliente',
      descricao: 'CNPJ do cliente onde ocorre o descarregamento da carga',
      obrigatorio: '',
    },
    {
      atributo: 'entrega.nome_cidade',
      descricao: 'Nome da cidade de coleta',
      obrigatorio: '',
    },
    {
      atributo: 'entrega.sigla_estado',
      descricao: 'Sigla do estado coleta(PR, RN, SP) etc...',
      obrigatorio: '',
    },
    {
      atributo: 'volume',
      descricao: 'Quantidade total em Toneladas do Produto',
      obrigatorio: <CheckOutlinedStyle />,
    },
    {
      atributo: 'cadencia',
      descricao: 'Quantidade em toneladas diária de carregamento',
      obrigatorio: <CheckOutlinedStyle />,
    },
    {
      atributo: 'valor_frete_motorista_pj',
      descricao: 'Valor em reais do frete recebido pelo motorista (PJ)',
      obrigatorio: '',
    },
    {
      atributo: 'valor_frete_motorista_pf',
      descricao: 'Valor em reais do frete recebido pelo motorista (PF)',
      obrigatorio: '',
    },
    {
      atributo: 'valor_frete_total_pj',
      descricao: 'Valor final do frete em reais (PJ)',
      obrigatorio: '',
    },
    {
      atributo: 'valor_frete_total_pf',
      descricao: 'Valor final do frete em reais (PJ)',
      obrigatorio: '',
    },
    {
      atributo: 'observacoes',
      descricao: 'Campo de observação',
      obrigatorio: '',
    },
    {
      atributo: 'data_inicio',
      descricao: 'Quando a Carga estará disponível',
      obrigatorio: <CheckOutlinedStyle />,
    },
    {
      atributo: 'data_fim',
      descricao: 'Prazo para o fim da oferta de carga',
      obrigatorio: '',
    },
  ];
  const columns = [
    {
      title: 'Atributo',
      dataIndex: 'atributo',
      key: 'atributo',
    },
    {
      title: 'Descrição',
      dataIndex: 'descricao',
      key: 'descricao',
    },
    {
      title: 'Obrigatório',
      dataIndex: 'obrigatorio',
      key: 'obrigatorio',
      align: 'center',
    },
  ];

  return (
    <>
      <SubHeader breadcrumbs={breadcrumbs} />
      <Card bordered={false} className="pt-15 height-85">
        <Typography>
          <Title level={2}>Integração de Lote Shipper</Title>
          <Title level={3}>Visão Geral</Title>
          <Paragraph>
            Incluir um lote dentro da plataforma TMOV Shipper pode ser feita
            através de um &nbsp;
            <Link href="https://pt.wikipedia.org/wiki/REST">
              Web Service REST
            </Link>
            , da mesma forma que a inserção dá-se nas modalidades&nbsp;
            <Text strong>Formulário</Text>
            &nbsp;e
            <Text strong> Importação CSV</Text>
            ,&nbsp;por meio da integração é possível que sistemas terceiros
            automaticamente comuniquem-se com o TMOV Shipper, abaixo serão
            abordadas as especificações técnicas necessárias para que a
            integração obtenha sucesso.
          </Paragraph>
          <Title level={3}>
            Autenticação -
            <Link href="https://api-auth-hml.sotran.com.br/api-docs/#/token/store">
              {' '}
              Swagger
            </Link>
          </Title>
          <Paragraph>
            Solicite juntamente ao time comercial a criação de um usuário de
            integração com as devidas permissões dentro da plataforma TMOV
            Shipper. Após a criação, você receberá um login e senha para
            garantir maior segurança entre a comunicação dos dados. Com login e
            senha, você estará apto a obter um
            <Link href="https://swagger.io/docs/specification/authentication/bearer-authentication/">
              {' '}
              Token de Autenticação
            </Link>
            , abaixo segue um exemplo para o consumo do Token utilizando &nbsp;
            <Link href="https://pt.wikipedia.org/wiki/CURL">cURL: </Link>
          </Paragraph>
          <Paragraph>
            <Text code copyable>
              curl --request POST \ --url
              https://api-shipper-hml.sotran.com.br/token \ --header
              'Content-Type: application/json' \ --header 'accept:
              application/json' \ --data
              '&#123;"login":"seuUsuario","password":"suaSenha"&#125;'
            </Text>
          </Paragraph>
          <Paragraph>
            O Token que obtido da chamada tem um tempo de expiração de 7 dias,
            necessitando a geração de um novo token quando expirado.
          </Paragraph>
          <Title level={3}>
            Integrar Carga - &nbsp;
            <Link href="https://api-shipper-hml.sotran.com.br/api-docs/">
              {' '}
              Swagger{' '}
            </Link>
          </Title>
          <Text code copyable>
            curl --request POST \ --url
            https://api-shipper-hml.sotran.com.br/v1/lotes-integracao/ \
            --header 'Authorization: Bearer Token' \ --header 'Content-Type:
            application/json' \ --data '&#123; "cliente_pagador_cnpj":
            "79114450003423", "produto_id": 1,"especie_id": 1,"origem":
            &#123;"cnpj_cliente": "", "nome_cidade": "corne
            Procopio","sigla_estado": "PR"&#125;, "destino":
            &#123;"cnpj_cliente": null,"nome_cidade": "londrina",
            "sigla_estado": "PR"&#125;,"coleta": &#123;"cnpj_cliente":
            null&#125;, "entrega": &#123;"cnpj_cliente": null,"nome_cidade":
            null, "sigla_estado": null&#125;,"volume": 1,"cadencia": 1,
            "valor_frete_motorista_pj": null,"valor_frete_motorista_pf": null,
            "valor_frete_total_pj": null,"valor_frete_total_pf": null,
            "observacoes": "Lote API","data_inicio": "12/04/2021", "data_fim":
            null &#125;'
          </Text>
          <Title level={4}>Detalhamento do corpo da requisição</Title>
          <Table columns={columns} dataSource={dadosAtributosPayload} />
        </Typography>
      </Card>
    </>
  );
}
